import { render } from "./Brokers.vue?vue&type=template&id=4bb862d1&scoped=true"
import script from "./Brokers.vue?vue&type=script&lang=js"
export * from "./Brokers.vue?vue&type=script&lang=js"

import "./Brokers.vue?vue&type=style&index=0&id=4bb862d1&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bb862d1"]])

export default __exports__